import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { ISettings, SETTINGS } from '@lsq-frontend/angular-shared/settings';
import { UserService } from '@lsq-frontend/angular-shared/features/user-service';
import { Observable } from 'rxjs';

@Injectable()
export class RequestInterceptor implements HttpInterceptor {
    private _userService: UserService;
    private _settings: ISettings;

    constructor(private _injector: Injector) {}

    public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this._userService = this._injector.get(UserService);
        this._settings = this._injector.get(SETTINGS);

        // Make sure all requests include a `companyKey`.
        if (
            request.body &&
            !request.body.companyKey &&
            request.url.includes(this._settings.httpApiServiceNameUrlMap.dashboard)
        ) {
            request.body.companyKey = this._userService.getCompanyKey();
        }

        return next.handle(request);
    }
}
